import './styles/default.scss';
import { Video } from '@/app/elements/video/video';
import { GameUrl } from '../../subcomponents/game-url/game-url';
import type { LauncherUrlProps } from '@/utils/url/launcher-url';
import BadgeFactory from '@/app/components/badge/badge-factory';
import { type BadgeType } from '@/types/badges';
import { getServerContext } from '@/store/server-context';
import { classes } from '@/utils/classes/classes';

type AnimatedTrailerProps = {
    uid: string;
    videoId: string;
    src: string;
    title: string;
    info: string;
    legal?: string;
    launcherUrlProps: LauncherUrlProps;
    label?: string;
    poster?: string;
    hideGameInfo?: boolean;
    tracking: {
        gameUid: string;
        gamePosition: number | null;
        gameName: string;
        gameProvider: string;
    };
};

export const AnimatedTrailerGame = ({
    uid,
    videoId,
    src,
    title,
    info,
    legal,
    launcherUrlProps,
    label,
    poster,
    hideGameInfo,
    tracking
}: AnimatedTrailerProps) => {
    const { isMobile } = getServerContext();
    return (
        <div
            className={classes(
                'animated-trailer',
                isMobile && 'animated-trailer--mobile',
                hideGameInfo && 'animated-trailer--no-info'
            )}
            data-t-gameuid={tracking.gameUid}
            data-t-gameposition={tracking.gamePosition}
            data-t-gamename={tracking.gameName}
            data-t-gameprovider={tracking.gameProvider}>
            {label && <BadgeFactory badgeType={label as BadgeType} />}
            {/* TODO: popup */}
            <GameUrl launcherUrlProps={launcherUrlProps}>
                <Video
                    uid={uid}
                    videoId={videoId}
                    src={src}
                    title={title}
                    info={info}
                    legal={legal}
                    poster={poster}
                    videosPlaying={true}
                    hasVideoDetails={!hideGameInfo}
                />
            </GameUrl>
        </div>
    );
};
